import React from "react";
//import PropTypes from 'prop-types';
import cn from "classnames";
import Popover from "components/Popover";
import SelectList, {
    SelectListItem,
    SelectListLabel,
} from "playground/ui/SelectList";
import Icon from "components/Icon";

const options = {
    media: "Dla wszystkich języków",
    "media-locale": "Inny plik w każdym języku",
};

export function MediaLocaleSelect(props) {
    const { onClick, label, value, onChange } = props;
    return (
        <SelectList onClick={onClick}>
            {label && <SelectListLabel>{label}</SelectListLabel>}
            {Object.keys(options).map((k) => (
                <SelectListItem
                    isSelected={value === k}
                    onClick={() => onChange(k)}
                >
                    {options[k]}
                </SelectListItem>
            ))}
        </SelectList>
    );
}

MediaLocaleSelect.propTypes = {};

MediaLocaleSelect.defaultProps = {};

export default MediaLocaleSelect;

function MediaLocaleButton({ onClick, value }) {
    return (
        <div
            className={cn("media-locale-btn", {
                "is-active": value === "media-locale",
            })}
            onClick={onClick}
        >
            Wersje językowe
            <Icon>mui-keyboard_arrow_down</Icon>
        </div>
    );
}

export function MediaLocaleSelectPopover(props) {
    const { value, onChange } = props;
    return (
        <Popover
            trigger={({ onClick }) => (
                <MediaLocaleButton onClick={onClick} value={value} />
            )}
            content={({ onClose }) => (
                <MediaLocaleSelect onClick={onClose} {...props} />
            )}
        />
    );
}
